import { render, staticRenderFns } from "./CoreLabel.vue?vue&type=template&id=7a70497a&scoped=true&"
import script from "./CoreLabel.vue?vue&type=script&lang=js&"
export * from "./CoreLabel.vue?vue&type=script&lang=js&"
import style0 from "./CoreLabel.vue?vue&type=style&index=0&id=7a70497a&prod&lang=css&"
import style1 from "./CoreLabel.vue?vue&type=style&index=1&id=7a70497a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a70497a",
  null
  
)

export default component.exports